import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  OnInit,
  ViewChild,
} from "@angular/core";
import { UntypedFormBuilder } from "@angular/forms";
import { MatDialog } from "@angular/material/dialog";
import { FlowServiceService } from "src/app/Services/flow-service.service";
import { OrgContextService } from "src/app/Services/org-context.service";
import { Subject, Subscription } from "rxjs";
import { debounceTime } from "rxjs/operators";

import { FlowQueryModel } from "src/app/models/flowquerymodel";
import { AnalyticsComponent } from "../../analyics/analytics.component";
import { Router } from "@angular/router";
import { EventEmitterService } from "src/app/Services/event-emitter.service";
@Component({
  selector: "app-dashboard",
  templateUrl: "./dashboard.component.html",
  styleUrls: ["./dashboard.component.scss"],
})
export class DashboardComponent implements OnInit, AfterViewInit {
  @ViewChild("likeCanvas") likeCanvas: ElementRef | undefined;
  @ViewChild("bookmarkCanvas") bookmarkCanvas!: { nativeElement: any };
  @ViewChild("salesCanvas") salesCanvas!: { nativeElement: any };
  @ViewChild("commentsCanvas") commentsCanvas!: { nativeElement: any };

  canvas: any;
  ctx: any;
  canvas1: any;
  ctx1: any;

  NoOfBookmarks: any;
  NoOfLikes: any;
  NoOfSales: any;
  NoOfComments: any;
  tabIndex: any;
  FlowCount: any;
  noApprovedFlows: any;
  noResultReturned: boolean = false;
  userEmail: string;
  dashboardModel: any;
  userData: any;
  isLoading: boolean = true;
  isDataLoading: boolean = true;
  private searchTerms = new Subject<string>();
  userDashboardModelDetails: any[] = [];
  input: string = "";
  linksClick: any;
  totalLinkClicks: number;
  totalGrossSales: any;
  totalNetSales: any;
  totalDonatedFunds: any;
  todayDonations: number = 0;
  weekDonations: number = 0;
  monthDonations: number = 0;
  donationData: any[] = [];
  selectedFilter: string = "";
  /** Organization content is never sold, so sales, prices and paid filters are hidden in org mode. */
  showPaidContent = true;
  private orgSub?: Subscription;
  private loadSub?: Subscription;
  blue = "#ofa";
  toogleMenuClass: boolean = false;
  isToggleClass!: boolean;

  constructor(
    private flowServiceService: FlowServiceService,
    // private toastr: ToastrService,
    public formbuilder: UntypedFormBuilder,
    public router: Router,
    private cdr: ChangeDetectorRef,
    public dialog: MatDialog,
    private eventEmitterService: EventEmitterService,
    private orgContext: OrgContextService
  ) {
    this.userDashboardModelDetails = [];
    console.log("In Dashboard component");
    this.searchTerms
      .pipe(debounceTime(400))
      .subscribe(() => {
        // Call your search function here
        this.performSearch();
      });
  }

  ngOnDestroy() {
    this.orgSub?.unsubscribe();
    this.loadSub?.unsubscribe();
  }

  /** Dashboard queries cover only the selected account: the active organization, or personal content. */
  private dashboardQuery(extra: Partial<FlowQueryModel> = {}): FlowQueryModel {
    return new FlowQueryModel({
      userEmail: this.userData.emailAddress,
      ...this.orgContext.accountScopeQuery(),
      ...extra,
    });
  }

  private scopeKey = "";

  private onAccountContextChanged(): void {
    this.showPaidContent = !this.orgContext.isOrganizationMode();
    const scope = this.orgContext.accountScopeQuery();
    const key = `${scope.accountScope}:${scope.organizationId || ""}`;
    const scopeChanged = key !== this.scopeKey;
    this.scopeKey = key;
    const paidFilter =
      this.selectedFilter === "Paid Flows" || this.selectedFilter === "Paid Bundles";
    const localFilter = this.selectedFilter === "Collaborated Flows";
    if ((!this.showPaidContent && paidFilter) || (scopeChanged && localFilter)) {
      this.handleFilter("All");
    } else if (scopeChanged) {
      this.handleFilter(this.selectedFilter || "All");
    }
  }

  performSearch() {
    if (!this.dashboardModel?.userDashboardModelDetails) {
      this.userDashboardModelDetails = [];
      return;
    }

    const baseList = this.filterOutDrafts(
      this.dashboardModel.userDashboardModelDetails
    );

    const term = (this.input || "").trim().toLowerCase();
    if (!term) {
      this.userDashboardModelDetails = baseList;
      return;
    }

    this.userDashboardModelDetails = baseList.filter((f) =>
      (f.flowName || "").toLowerCase().includes(term)
    );
  }

  async ngOnInit(): Promise<void> {
    this.userData = JSON.parse(localStorage.getItem("LoggedInUser"));
    this.userEmail = "";
    if (this.userData != null && this.userData.emailAddress) {
      this.eventEmitterService.setDashboardMenuStyleProperty("dashboard");

      this.userEmail = this.userData.emailAddress;

      this.userDashboardModelDetails = [];
      this.selectedFilter = "All";
      this.getDonationData(); // Fetch donation data
      // Emits immediately, which runs the first load for the selected account.
      this.orgSub = this.orgContext.watch().subscribe(() => this.onAccountContextChanged());
      this.cdr.detectChanges(); // Ensures Angular detects changes
    } else {
      this.router.navigate(["/login"], {
        queryParams: { returnUrl: this.router.url },
      });
    }
  }

  selectedFilterValue(value: any) {
    switch (value) {
      case value == "All":
        this.selectedFilter = "All";
        break;
      case value == "Flows":
        this.selectedFilter = "Flows";
        break;
      case value == "Bundles":
        this.selectedFilter = "Bundles";
        break;
      case value == "Paid Flows":
        this.selectedFilter = "Paid Flows";
        break;
      case value == "Paid Bundles":
        this.selectedFilter = "Paid Bundles";
        break;
    }
  }

  /** Covers that failed to load — fall back to title initials instead of a placeholder image. */
  private readonly failedCovers = new Set<string>();
  private readonly videoExtensions = [
    "mp4",
    "mov",
    "wmv",
    "flv",
    "avi",
    "mkv",
    "webm",
    "m4v",
    "3gp",
  ];

  /** Uses dashboard FlowUrl (API sends a still image / poster). Initials only when there is no usable cover. */
  hasCover(flow: any): boolean {
    const id = `${flow?.id || flow?.Id || ""}`;
    if (id && this.failedCovers.has(id)) return false;
    return !!this.coverSrc(flow);
  }

  coverSrc(flow: any): string {
    const url = `${flow?.flowUrl || flow?.FlowUrl || ""}`.trim();
    const thumb = `${
      flow?.videoThumbNailUrl || flow?.VideoThumbNailUrl || ""
    }`.trim();
    if (this.isVideoUrl(url)) return thumb;
    return url || thumb;
  }

  coverInitial(flow: any): string {
    const name = `${flow?.flowName || flow?.FlowName || ""}`
      .replace(/<[^>]*>/g, "")
      .trim();
    const letter = name.charAt(0);
    return letter ? letter.toUpperCase() : "G";
  }

  onCoverError(flow: any): void {
    const id = `${flow?.id || flow?.Id || ""}`;
    if (id) this.failedCovers.add(id);
  }

  private isVideoUrl(url: string): boolean {
    if (!url) return false;
    const ext = (url.split("?")[0].split(".").pop() || "").toLowerCase();
    return this.videoExtensions.includes(ext);
  }

  goToFlowOrBundle(flow) {
    this.eventEmitterService.setPageDashboardProperty(false);
    localStorage.setItem("notificationflowId", null);
    //localStorage.setItem("flow", JSON.stringify(flow));
    localStorage.removeItem("flow"); //, JSON.stringify(flow));
    localStorage.setItem("navigateTo", "/");
    console.log(flow);
    if (flow.flowType == "Bundle") {
      //this.isItBundle = true;
      console.log(flow.flowType);
      this.router.navigate(["/view-guide-pack/" + flow.id]);
    } else {
      //this.isItBundle = false;
      this.router.navigate([
        `/guide/${this.generateUrlSlug(flow.flowName)}/${flow.id}`,
      ]);
    }
  }

  generateUrlSlug(html) {
    if (!html) return "";
    return html
      .replace(/<[^>]*>/g, "") // Remove HTML tags
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "") // Remove accents (é → e, ñ → n)
      .replace(/[^a-zA-Z0-9\s-]/g, "") // Remove special characters except spaces and "-"
      .trim() // Trim spaces from start/end
      .replace(/\s+/g, "-") // Replace spaces with "-"
      .replace(/-+/g, "-") // Remove duplicate dashes
      .toLowerCase(); // Convert to lowercase
  }

  getLinksContentCount() {
    var flowModel = new FlowQueryModel({
      userEmail: this.userData.emailAddress,
    });

    this.noResultReturned = true;
    // this.bundleService.getAllBundleLinkClicks(flowModel).subscribe((data) => {
    //   console.log(data);
    //   this.noResultReturned = false;
    //   // this.dashboardModel = data.DashboardModel;
    //   this.linksClick = data;
    //   this.calculateTotalLinkClicks();
    // });
  }
  handleFilter(filterType: string) {
    this.selectedFilter = "";
    // Implement your logic to handle the filter selection here
    let filter: any;
    switch (filterType) {
      case "All":
        filter = "All";
        this.getAll();
        break;
      case "Flows":
        filter = "Flows";
        this.getFlows();
        break;
      case "Bundles":
        filter = "Bundles";
        this.getBundles();
        break;
      case "Paid Flows":
        filter = "Paid Flows";
        this.getPaidFlows();
        break;
      case "Paid Bundles":
        filter = "Paid Bundles";
        this.getPaidBundles();
        break;
      case "Collaborated Flows":
        filter = "Collaborated Flows";
        this.getCollaboratedFlowsLocal();
        break;
      default:
        filter = "";
        // Handle default case or throw error
        break;
    }
    console.log("filter", filter);
    this.selectedFilter = filter;
  }
  getAll() {
    this.getUserDashboard(this.dashboardQuery());
  }

  getToAnalytics() {
    this.eventEmitterService.setDashboardMenuStyleProperty("analytics");
    this.router.navigateByUrl("/user-dashboard/content-analytics");
  }
  getToDonation() {
    this.router.navigateByUrl("/user-dashboard/gift");
  }
  getToConsultation() {
    this.router.navigateByUrl("/user-dashboard/pending-consultations");
  }
  getFlows() {
    this.loadSub?.unsubscribe();
    this.loadSub = this.flowServiceService
      .getUserDashboardFlows(this.dashboardQuery({ FlowType: "Flow" }))
      .subscribe((data) => {
        this.processDashboardData(data);
      });
  }

  getBundles() {
    this.loadSub?.unsubscribe();
    this.loadSub = this.flowServiceService
      .getUserDashboardBundles(this.dashboardQuery({ FlowType: "Bundles" }))
      .subscribe((data) => {
        this.processDashboardData(data);
      });
  }

  getPaidFlows() {
    this.loadSub?.unsubscribe();
    this.loadSub = this.flowServiceService
      .getUserDashboardPaidFlows(this.dashboardQuery({ FlowType: "Flow" }))
      .subscribe((data) => {
        this.processDashboardData(data);
      });
  }
  addMenutoggleClass() {
    console.log(this.toogleMenuClass);
    this.toogleMenuClass = !this.toogleMenuClass;
    this.isToggleClass = false;
  }
  getCollaboratedFlowsLocal() {
    if (!this.dashboardModel?.userDashboardModelDetails) {
      this.userDashboardModelDetails = [];
      return;
    }
    this.userDashboardModelDetails = this.filterOutDrafts(
      this.dashboardModel.userDashboardModelDetails
    ).filter((f) => f.isCollaborated === true);
    this.calculateTotalSale(this.userDashboardModelDetails);
  }
  getPaidBundles() {
    this.loadSub?.unsubscribe();
    this.loadSub = this.flowServiceService
      .getUserDashboardPaidBundles(this.dashboardQuery({ FlowType: "Bundles" }))
      .subscribe((data) => {
        this.processDashboardData(data);
      });
  }

  processDashboardData(data: any) {
    this.noResultReturned = true;
    this.dashboardModel = data;
    console.log(this.dashboardModel);
    this.userDashboardModelDetails = this.filterOutDrafts(
      this.dashboardModel.userDashboardModelDetails || []
    );
    this.noResultReturned = false;
    this.calculateTotalSale(this.userDashboardModelDetails);
  }

  /**
   * Remove draft flows from the dashboard content list.
   * Relies on common backend flags but falls back safely if properties are missing.
   */
  private filterOutDrafts(list: any[]): any[] {
    if (!Array.isArray(list)) return [];
    return list.filter((item) => {
      const status =
        (item.status || item.flowStatus || item.flowStatusText || "").toString();
      const isDraftFlag = item.isDraft === true || item.draft === true;
      return !isDraftFlag && status.toLowerCase() !== "draft";
    });
  }

  calculateTotalLinkClicks() {
    this.totalLinkClicks = 0;

    for (let content of this.linksClick) {
      this.totalLinkClicks += content.totalCount;
    }
  }
  searchFlow() {
    this.searchTerms.next(this.input);
  }

  async getUserDashboard(flowQueryModel) {
    this.isLoading = true;
    this.isDataLoading = true;
    this.noResultReturned = true;

    this.loadSub?.unsubscribe();
    this.loadSub = this.flowServiceService.getUserDashboard(flowQueryModel).subscribe({
      next: (data) => {
        console.log(data);
        this.noResultReturned = false;
        this.dashboardModel = data;
        console.log(this.dashboardModel?.totalNnumberOfFlows);

        if (this.dashboardModel.totalViews == null) {
          this.dashboardModel.totalViews = 0;
        }
        this.userDashboardModelDetails =
          this.dashboardModel.userDashboardModelDetails;
        console.log(this.userDashboardModelDetails);
        setTimeout(() => this.cdr.detectChanges(), 0); // 🔥 Force update after data binding
        this.getLinksContentCount();
        this.calculateTotalSale(this.dashboardModel?.userDashboardModelDetails);
        this.cdr.markForCheck();
        this.cdr.detectChanges();

        // Set loading states to false after data is loaded
        this.isLoading = false;
        this.isDataLoading = false;
      },
      error: (error) => {
        console.error("Error loading dashboard data:", error);
        this.isLoading = false;
        this.isDataLoading = false;
        this.noResultReturned = false;
      },
    });
  }
  calculateTotalSale(data) {
    this.totalGrossSales = 0;
    this.totalNetSales = 0;

    data.forEach((element) => {
      this.totalGrossSales += element.totalGrossSales;
      this.totalNetSales += element.totalNetSales;
    });

    // Round to two decimal places
    this.totalGrossSales = this.totalGrossSales.toFixed(2);
    this.totalNetSales = this.totalNetSales.toFixed(2);

    console.log(this.totalGrossSales);
    console.log(this.totalNetSales);

    this.cdr.detectChanges();
  }

  /**
   * Calculate time-based donation statistics
   */
  calculateDonationStats(): void {
    const now = new Date();
    this.todayDonations = 0;
    this.weekDonations = 0;
    this.monthDonations = 0;

    if (this.donationData && this.donationData.length > 0) {
      this.donationData.forEach((donation) => {
        const receivedDate = new Date(donation.receivedDate);
        const fundAmount = donation.fund || 0;

        // Today's donations
        if (
          receivedDate.getDate() === now.getDate() &&
          receivedDate.getMonth() === now.getMonth() &&
          receivedDate.getFullYear() === now.getFullYear()
        ) {
          this.todayDonations += fundAmount;
        }

        // This week's donations (last 7 days)
        const weekAgo = new Date(now);
        weekAgo.setDate(weekAgo.getDate() - 7);
        if (receivedDate >= weekAgo) {
          this.weekDonations += fundAmount;
        }

        // This month's donations
        if (
          receivedDate.getMonth() === now.getMonth() &&
          receivedDate.getFullYear() === now.getFullYear()
        ) {
          this.monthDonations += fundAmount;
        }
      });
    }
  }

  /**
   * Fetch donation data for the current user
   */
  getDonationData(): void {
    if (this.userData && this.userData.rowKey) {
      const flowQueryModel = new FlowQueryModel({
        FlowId: this.userData.rowKey,
      });

      this.flowServiceService
        .getGiftedFundsByCustomerRowKey(flowQueryModel)
        .subscribe((data) => {
          this.donationData = data || [];
          this.calculateDonationStats();
          this.cdr.detectChanges();
        });
    }
  }

  analyticsPage(flow) {
    localStorage.setItem("analyticsflow", JSON.stringify(flow));
    
    // Check if device is mobile
    const isMobile = window.innerWidth <= 768;

    const dialogRef = this.dialog.open(AnalyticsComponent, {
      panelClass: "analytics-dialog",
      width: isMobile ? "100vw" : "95vw",
      maxWidth: isMobile ? "100vw" : "1200px",
      height: isMobile ? "100vh" : "90vh",
      maxHeight: isMobile ? "100vh" : "90vh",
      disableClose: false,
      autoFocus: true,
      restoreFocus: true,
      hasBackdrop: true,
      backdropClass: "analytics-backdrop",
      position: isMobile ? { top: "0", left: "0" } : undefined,
    });
    dialogRef.afterClosed().subscribe((result) => {});
  }
  ngAfterViewInit(): void {
    this.eventEmitterService.setDashboardMenuStyleProperty("dashboard");
  }

  tabChanged(event) {}
}
